/* lua.js generated code 0.3.0 */

var MAX_NUM = 999
var PropBagItem = xClass("PropBagItem", cc.Node)
PropBagItem.prototype.ctor = function (ui, bagId, itemData) {
    var self = this
    cc.Node.prototype.ctor.call(self)
    self.ui = ui
	self.bagId = bagId
	self.itemData = itemData
	self.itemId = self.itemData.itemId
	self.num = self.itemData.num
	self.isTime = self.itemData.timelimit
	self.expireTime = self.itemData.expireTime
    self.icon = null
    self.numLabel = null
    self.onClickCallback = null
    self.init()
}
/*PropBagItem.prototype.stopTimer = function () {
    var self = this
    if (self.timerId) {
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.timerId)
        self.timerId = null
    }
}*/
PropBagItem.prototype.createNumLabel = function () {
    var self = this
	var numStr = self.num > MAX_NUM && (tostring(MAX_NUM) + "+") || tostring(self.num)
	self.numLabel = self.ui.getChildByName("num2")
	self.numLabel.setString(numStr)
    // 道具本身可控制是否显示数字角标
	if (self.icon && (self.icon.noneNum || self.icon.time)) { 
		self.numLabel.setVisible(false)
        //调整限时/无限道具的层级
		if (self.icon.time) { 
			var tag = self.icon.time
			var coundownAct = tag.getActionByTag(99)
			coundownAct.retain()
			tag.retain()
			tag.removeFromParent()
			var tagSample = self.ui.getChildByName("bag_limited")
			tag.setPosition(tagSample.getPosition())
			tag.setScale(tagSample.getScale())
			self.ui.addChild(tag)
			tag.runAction(coundownAct)
			tag.release()
			coundownAct.release()
        }
    }
	else{
		self.numLabel.setVisible(true)
        //下调icon位置
		self.icon.setPositionY(-15) 
    }
    return self.numLabel
}
PropBagItem.prototype.init = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
	var size = cc.size(86, 86)
	var propMeta = MetaManager.getInstance().getPropMeta(self.itemId)

	if (propMeta && propMeta.islandProp) {
		self.icon = cc.Node.create()
		var _icon = IslandPropIcon.create(self.itemId, true, self.expireTime)
		_icon.setScale(0.85)
		_icon.setPosition(-55, -43)
		self.icon.addChild(_icon)
		self.icon.setContentSize(size)
		self.icon.time = _icon.time
    }else{
        self.icon = UIItemBuilder.createPropIconNew(self.itemId, self.expireTime, false)
        self.icon.setScale(size.height/self.icon.getContentSize().height)
    }
    self.addChild(self.icon)
	if (propMeta) {

		self.ui.getChildByName("bag_guanqian").setVisible(UserPropData.isBagPreLevelProp(self.itemId))
		self.ui.getChildByName("bag_guannei").setVisible(UserPropData.isBagInLevelProp(self.itemId))
    } 
    let btn = UIButton.create(self.icon)
    btn.on(UIButtonEvent.Click, function () {
        self.onClick()
    })
}
/*PropBagItem.prototype.init = function () {
    var self = this
    self.icon = cc.Sprite.createWithSpriteFrameName("properties/prop_" + tostring(self.itemId) + ".png")
    self.addChild(self.icon)
    if (self.isTime) {
        var limitTimeLabel = cc.CSLoader.createNode("cocos/prop_bag_panel_timelimit.csb")
        self.timeLabel = limitTimeLabel.getChildByName("txt")
        self.timeLabelBg = limitTimeLabel.getChildByName("bg")
        self.timeLabel.setContentSize(cc.size(100, self.timeLabel.getContentSize().height))
        limitTimeLabel.setPosition(cc.p(-65, 52))
        self.addChild(limitTimeLabel)
        self.updateRestTime()
    }
    var btn = UIButton.create(self.icon)
    btn.on(UIButtonEvent.Click, function () {
        self.onClick()
    })
    if (self.isTime) {
        function scheduleCountdown() {
            self.updateRestTime()
        }
        self.timerId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(scheduleCountdown, 1, false)
        // function onNodeEvent(event) {
        //     if (event === "exit") {
        //         self.stopTimer()
        //     }
        // }
        // self.registerScriptHandler(onNodeEvent)
    }
}

PropBagItem.prototype.cleanup = function () {
    let self = this
    cc.Node.prototype.cleanup.call(this)
    if(!self.timerId){
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.timerId)
        self.timerId = null
    }
}

PropBagItem.prototype.updateRestTime = function () {
    var self = this
    var timeLeft = self.expireTime / 1000 - Localhost.timeInSec()
    var size = self.timeLabelBg.getContentSize()
    if (timeLeft < 0) {
        self.timeLabelBg.setContentSize(80, size.height)
        self.timeLabel.setString(getText("prop.time.over"))
    } else if (timeLeft < 3 * 3600) {
        self.timeLabelBg.setContentSize(95, size.height)
        self.timeLabel.setString("即将到期")
    } else {
        self.timeLabelBg.setContentSize(50, size.height)
        self.timeLabel.setString("限")
    }
}*/
PropBagItem.prototype.updateItemNum = function () {
    var self = this
	self.num = self.itemData.num
	var numStr = self.num > MAX_NUM && (tostring(MAX_NUM) + "+") || tostring(self.num)
	self.numLabel.setString(numStr)
}
PropBagItem.prototype.onClick = function () {
    var self = this
    self.onClickCallback(self.bagId)
}
PropBagItem.prototype.playSelectAnim = function () {
    var self = this
    self.icon.runAction(cc.Sequence.create(cc.ScaleTo.create(0.2, 1.1), cc.ScaleTo.create(0.2, 1.0)))
}
module.exports = PropBagItem
